import Vue from 'vue';
import VueRouter from 'vue-router';
import AppPlugin from './plugins/app';
import VModal from 'vue-js-modal';

var router = new VueRouter({
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    routes: [
        { path: '/', component: require('./pages/index.vue') },
        { path: '/login', component: require('./pages/login.vue') },
        { path: '/dashboards', component: require('./pages/dashboards.vue') },
        { path: '/dashboards/save', component: require('./pages/dashboard_save.vue') },
        { path: '/dashboards/pageview', component: require('./pages/dashboard/pageview.vue'),
            children: [
                { path: 'event-type', component: require('./pages/dashboard/pageview/event_type.vue')},
                { path: 'sum', component: require('./pages/dashboard/pageview/sum.vue')}
            ]
        },
        { path: '/dashboards/refund', component: require('./pages/dashboard/refund.vue'),
            children: [
                { path: 'maya', component: require('./pages/dashboard/refund/maya.vue')},
                { path: 'sum', component: require('./pages/dashboard/refund/sum.vue')},
                { path: 'agent', component: require('./pages/dashboard/refund/agent.vue')},
                { path: 'iban', component: require('./pages/dashboard/refund/iban.vue')}
            ]
        },
        { path: '/dashboards/charging/', component: require('./pages/dashboard/charging.vue'),
            children: [
                { path: 'operator', component: require('./pages/dashboard/charging/operator.vue')},
                { path: 'total', component: require('./pages/dashboard/charging/total.vue')},
                { path: 'type', component: require('./pages/dashboard/charging/type.vue')}
            ]
        },
        { path: '/dashboards/subscription', component: require('./pages/dashboard/subscription.vue'),
            children: [
                { path: 'operator', component: require('./pages/dashboard/subscription/operator.vue')},
                { path: 'total', component: require('./pages/dashboard/subscription/total.vue')},
                { path: 'mecra', component: require('./pages/dashboard/subscription/mecra.vue')}
            ]
        },
        { path: '/dashboards/subscharging', component: require('./pages/dashboard/subscharging.vue'),
            children: [
                { path: 'sum', component: require('./pages/dashboard/subscharging/sum.vue')},
                { path: 'old-record-status', component: require('./pages/dashboard/subscharging/old_record_status.vue')}
            ]
        },
        { path: '/dashboards/appsale', component: require('./pages/dashboard/appsale.vue'),
            children: [
                { path: 'countries', component: require('./pages/dashboard/appsale/countries.vue')},
                { path: 'country', component: require('./pages/dashboard/appsale/country.vue')},
                { path: 'time', component: require('./pages/dashboard/appsale/time.vue')},
                { path: 'packages', component: require('./pages/dashboard/appsale/packages.vue')}
            ]
        },
        { path: '/dashboards/appshare', component: require('./pages/dashboard/appshare.vue'),
            children: [
                { path: 'countries', component: require('./pages/dashboard/appshare/countries.vue')},
                { path: 'country', component: require('./pages/dashboard/appshare/country.vue')}
            ]
        },
        { path: '/dashboards/appdeeplink', component: require('./pages/dashboard/appdeeplink.vue'),
            children: [
                { path: 'countries', component: require('./pages/dashboard/appdeeplink/countries.vue')},
                { path: 'country', component: require('./pages/dashboard/appdeeplink/country.vue')},
                { path: 'sum', component: require('./pages/dashboard/appdeeplink/sum.vue')}
            ]
        },
        { path: '/dashboards/callrecord', component: require('./pages/dashboard/callrecord.vue') },
        { path: '/dashboards/appverification', component: require('./pages/dashboard/appverification.vue'),
            children: [
                { path: 'countries', component: require('./pages/dashboard/appverification/countries.vue')}
            ]
        },
        { path: '/dashboards/getcontact', component: require('./pages/dashboard/getcontact.vue'),
            children: [
                { path: 'phone-book', component: require('./pages/dashboard/getcontact/phone_book.vue')},
                { path: 'msisdn', component: require('./pages/dashboard/getcontact/msisdn.vue')},
                { path: 'msisdn-summary', component: require('./pages/dashboard/getcontact/msisdn_summary.vue')},
                { path: 'spam-choices', component: require('./pages/dashboard/getcontact/spam_choices.vue')},
                { path: 'spam-choice', component: require('./pages/dashboard/getcontact/spam_choice.vue')},
                { path: 'search', component: require('./pages/dashboard/getcontact/search.vue')},
                { path: 'spam-top', component: require('./pages/dashboard/getcontact/spam_top.vue')},
                { path: 'call-history', component: require('./pages/dashboard/getcontact/call_history.vue')},
                { path: 'call-history-top', component: require('./pages/dashboard/getcontact/call_history_top.vue')}
            ]
        },
        { path: '/dashboards/pushnotification', component: require('./pages/dashboard/pushnotification.vue'),
            children: [
                { path: 'sum', component: require('./pages/dashboard/pushnotification/sum.vue')},
            ]
        },
        { path: '/dashboards/translate', component: require('./pages/dashboard/translate.vue'),
            children: [
                { path: 'character-countries', component: require('./pages/dashboard/translate/character_countries.vue')},
            ]
        },
        { path: '/dashboards/whatsit', component: require('./pages/dashboard/whatsit.vue'),
            children: [
                { path: 'character-countries', component: require('./pages/dashboard/whatsit/character_countries.vue')},
            ]
        },
        { path: '/dashboards/metric', component: require('./pages/dashboard/metric.vue'),
            children: [
                { path: 'event-tps', component: require('./pages/dashboard/metric/event_tps.vue')},
            ]
        },
        { path: '/dashboards/iosappranking', component: require('./pages/dashboard/iosappranking.vue'),
            children: [
                { path: 'applications/:feed', component: require('./pages/dashboard/iosappranking/applications.vue'), props: true},
                { path: 'popular-new', component: require('./pages/dashboard/iosappranking/popular_new.vue'), props: true}
            ]
        },
        { path: '/services', component: require('./pages/services.vue') },
        { path: '/services/save', component: require('./pages/service_save.vue') },
        { path: '/users', component: require('./pages/users.vue') },
        { path: '/users/save', component: require('./pages/user_save.vue') },
        { path: '/api-users', component: require('./pages/api_users.vue') },
        { path: '/api-users/save', component: require('./pages/api_user_save.vue') },
        { path: '*', component: require('./pages/not_found.vue') }
    ]
});

Vue.use(VModal, {dialog: true});
Vue.use(VueRouter);
Vue.use(AppPlugin, {router: router});
var app = new Vue({
    el: '#app',
    router: router
});



// WEBPACK FOOTER //
// ./public/src/app.js